import { render, staticRenderFns } from "./IpAddressList.vue?vue&type=template&id=b36771fe&"
import script from "./IpAddressList.vue?vue&type=script&lang=js&"
export * from "./IpAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports